import { defineMessages } from "react-intl";

const messages = defineMessages({
  calculatedFieldWarning: {
    id: "integrations.setupStep.calculatedField.warning",
    defaultMessage:
      "Please note, this field is calculated from other fields and will only sync from MMC to your CRM.",
    description: "Calculated field warning for setup step",
  },
  crmDisplayName: {
    id: "integrations.fieldMappingTable.column.crmDisplayName",
    defaultMessage: "{serviceName} Field",
    description: "Title of a crmDisplayName field",
  },
  mmcField: {
    id: "integrations.fieldMappingTable.column.mmcField",
    defaultMessage: "Map My Customers Field {infoIcon}",
    description: "Title of a mmcField field",
  },
  mmcGroupField: {
    id: "integrations.fieldMappingTable.column.mmcGroupField",
    defaultMessage: "Create Group {infoIcon}",
    description: "Create Group",
  },
  syncing: {
    id: "integrations.fieldMappingTable.column.syncing",
    defaultMessage: "Sync Enabled",
    description: "Title of a syncing field",
  },
  territoryWarning: {
    id: "integrations.setupStep.territoryField.warning",
    defaultMessage:
      "Please note that Territories will only sync from MMC to your CRM. It is not possible to modify Territories via integrations.",
    description: "Territory field warning for setup step",
  },
  uniqueAlert: {
    id: "integrations.fieldMappingTable.column.uniqueAlert",
    defaultMessage: "Each value <b>must</b> be unique to sync.",
    description: "Each value must be unique to sync alert message",
  },
});

export default messages;
